import { useState } from "react";

const initialTriggers = [
  {
    id: 1,
    name: "Prospect Stage",
    status: "Active",
    description: "Stage is Win and HQ is Tel Aviv, or Stage is Win and HQ is London",
    createdDate: "19/10/25",
    createdBy: "Shelly Rosenberg",
    autoTrigger: true,
    sequences: [
      [
        { field: 'stage', type: 'exact', value: 'Win', key: 't1_seq1_filter1' },
        { field: 'hq', type: 'exact', value: 'Tel Aviv', key: 't1_seq1_filter2' }
      ],
      [
        { field: 'stage', type: 'exact', value: 'Win', key: 't1_seq2_filter1' },
        { field: 'hq', type: 'exact', value: 'London', key: 't1_seq2_filter2' }
      ]
    ]
  },
  {
    id: 2,
    name: "Prospect Stage",
    status: "Inactive",
    description: "Stage is Win and HQ is Tel Aviv, or Stage is Win and HQ is London",
    createdDate: "19/10/25",
    createdBy: "Shelly Rosenberg",
    autoTrigger: false,
    sequences: [
      [
        { field: 'stage', type: 'exact', value: 'Win', key: 't2_seq1_filter1' },
        { field: 'hq', type: 'exact', value: 'Tel Aviv', key: 't2_seq1_filter2' }
      ],
      [
        { field: 'stage', type: 'exact', value: 'Win', key: 't2_seq2_filter1' },
        { field: 'hq', type: 'exact', value: 'London', key: 't2_seq2_filter2' }
      ]
    ]
  }
];

export const useTriggers = () => {
  const [triggers, setTriggers] = useState(initialTriggers);

  const handleDeactivateTrigger = (triggerId) => {
    const updatedTriggers = triggers.map(trigger => {
      if (trigger.id === triggerId) {
        const newStatus = trigger.status === "Active" ? "Inactive" : "Active";
        console.log(`${newStatus === "Active" ? "Activated" : "Deactivated"} trigger:`, trigger.name);
        return { ...trigger, status: newStatus };
      }
      return trigger;
    });
    setTriggers(updatedTriggers);
  };

  const handleDeleteTrigger = (triggerId) => {
    if (window.confirm("Are you sure you want to delete this trigger?")) {
      const updatedTriggers = triggers.filter(t => t.id !== triggerId);
      setTriggers(updatedTriggers);
      console.log("Deleted trigger with id:", triggerId);
    }
  };

  const handleSaveTrigger = (triggerData, editingTriggerId) => {
    const generateDescription = (sequences) => {
      return sequences.map((seq) => {
        const conditions = seq.map(filter =>
          `${filter.field} ${filter.type} ${Array.isArray(filter.value) ? filter.value.join(', ') : filter.value}`
        ).join(' and ');
        return conditions;
      }).join(', or ');
    };

    if (editingTriggerId) {
      const updatedTriggers = triggers.map(trigger => {
        if (trigger.id === editingTriggerId) {
          return {
            ...trigger,
            name: triggerData.name,
            status: triggerData.status ? "Active" : "Inactive",
            autoTrigger: triggerData.autoTrigger,
            sequences: triggerData.sequences,
            description: generateDescription(triggerData.sequences)
          };
        }
        return trigger;
      });
      setTriggers(updatedTriggers);
      console.log("Updated trigger:", triggerData.name);
    } else {
      const newTrigger = {
        id: Math.max(...triggers.map(t => t.id)) + 1,
        name: triggerData.name,
        status: triggerData.status ? "Active" : "Inactive",
        description: generateDescription(triggerData.sequences),
        createdDate: new Date().toLocaleDateString('en-GB'),
        createdBy: "Current User",
        autoTrigger: triggerData.autoTrigger,
        sequences: triggerData.sequences
      };
      setTriggers([...triggers, newTrigger]);
      console.log("Created new trigger:", triggerData.name);
    }
  };

  return {
    triggers,
    handleDeactivateTrigger,
    handleDeleteTrigger,
    handleSaveTrigger,
  };
};
